
import Api from '@/services/Index';

const getReservations = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/library/rooms/reservation/list', config);
}

const saveReservation = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/library/reservations', config);
}
const libraryReservation = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/library/reservations', config);
}
const cancelReservation = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/library/reservations/cancel/'+id, data);
}
const cancelReservationAdmin = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/library/reservations/change-status/'+id, data);
}
const excelExport = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/library/reservations/excel-export', config);
}
const openDoor = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/library/rooms/' + id + '/device-control');
}
const bulkCancel = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/library/reservations/bulk-cancel', data);
}
const libraryHolidays = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/library/holidays', config);
}
export default {
    getReservations,
    saveReservation,
    libraryReservation,
    cancelReservation,
    excelExport,
    openDoor,
    cancelReservationAdmin,
    bulkCancel,
    libraryHolidays
}
